import React from 'react';
import { AlertCircle } from 'lucide-react';
import { getSubscriptionBannerMessage } from './subscriptionMessaging';

/**
 * Banner shown when the organization's subscription is inactive.
 * User has read-only access; write actions are disabled in the UI and blocked by the API.
 */
const SubscriptionBanner = ({ user }) => (
  <div
    className="bg-amber-500/90 dark:bg-amber-600/90 text-amber-950 dark:text-amber-50 px-4 py-2 text-center text-sm sticky top-0 z-[55]"
    role="alert"
  >
    <div className="flex items-center justify-center gap-2">
      <AlertCircle className="w-4 h-4 flex-shrink-0" />
      <span>
        {getSubscriptionBannerMessage(user)}
      </span>
    </div>
  </div>
);

export default SubscriptionBanner;
